import React, { Component } from "react";
import "./loaders.scss";
import anime from "animejs";

class Loader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clickEnable: false,
      continuing: false,
      txtResult: null,
    };
    this.vidElem = React.createRef();
  }

  componentDidMount() {
    if (window.screen.height < 100 || window.screen.width < 100) {
      console.warn("Lock");
      this.setState({
        continuing: false,
        clickEnable: false,
        txtResult: "Mobile version not available",
      });
    } else {
      this.startLoad();
      this.vidElem.play();
      window.setTimeout(() => {
        this.setState({
          clickEnable: true,
        });
        if (!this.props.required) {
          this.props.onLoaded();
        }
        //this.props.onLoaded();
      }, this.props.timeLoad);
      this.anim = anime({
        targets: [".vid-load"],
        //translateX: ['5rem', '-5rem'],
        translateY: ["-17rem", "6em", "27rem", "6em"],
        rotate: 180,
        borderRadius: "8px",
        duration: 6500,
        loop: true,
      });
    }
  }

  sleepT(milliseconds) {
    const date = Date.now();
    let currentDate = null;
    do {
      currentDate = Date.now();
    } while (currentDate - date < milliseconds);
  }

  startLoad = async () => {
    if (this.vidElem.paused) {
    }
  };
  stopLoad = () => {
    this.vidElem.pause();
  };

  onClickVisitor = () => {
    if (this.state.clickEnable) {
      this.setState({
        continuing: true,
      });
      setTimeout(() => {
        this.props.onLoaded();
      }, 1000);
    }
  };

  render() {
    return (
      <section
        onClick={() => this.onClickVisitor()}
        onMouseLeave={this.stopLoad}
        onMouseOut={this.stopLoad}
        onMouseMove={this.startLoad}
        className={"content-loader cur-p"}
      >
        <video
          onCanPlay={this.startLoad}
          autoPlay
          id={"vd-load"}
          ref={(velem) => {
            this.vidElem = velem;
          }}
          width={"30%"}
          loop
          src="https://static.gaviria.org/anm.mp4"
          className={"-pe vid-load"}
          controls={false}
          tabInsdex="-1"
        />
        <div className="txt-loading">
          <h1>
            <p
              className={`${
                this.state.txtResult != null ? "fs-10" : "fs-17   "
              }`}
            >
              <span className={`ls-th`}>173:~ cristiangaviria$</span>
              <span className={this.state.txtResult != null ? "" : "ls-md"}>
                &nbsp;
                {this.state.continuing
                  ? "Continuing..."
                  : this.state.clickEnable
                  ? "Click to continue.."
                  : this.state.txtResult != null
                  ? this.state.txtResult
                  : "Loading . . . . . ."}
              </span>
            </p>
          </h1>
        </div>
        <div>
          <span>This site has been building</span>
        </div>
      </section>
    );
  }
}
export default Loader;
